/**
 * Deliberate homonym of `Application/FacilityUsers/Queries/FetchFacilityUsers.ts`: both target the
 * same route. This one carries the extra `accountId` and `queryParams` the admin screen's server-side
 * filtering and `usersStore` ownership key need; the other is a bare `facilityId`, matching the
 * unfiltered directory read it feeds.
 */
class FetchFacilityUsers {
	constructor(
		// The store's ownership key (`usersFetched(payload, accountId)`), independent of `facilityId`
		// below — every facility belongs to this account, but the dispatched action always carries
		// `accountId`, never `facilityId`, so the store can tell whose list it holds.
		public readonly accountId: number,
		public readonly facilityId: number,
		// Already composed by the `UserFilterView` (`page`, `rows`, `search`, `roleId`, `facilityId`,
		// `isActive`, `pendingInvitation`, sort) — this Query does not know the filter shape.
		public readonly queryParams: URLSearchParams,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		return this.queryParams.toString();
	}
}

export default FetchFacilityUsers;
